import { defineMessages } from 'react-intl';

/**
 * The copy of the account sections of Instagram, Facebook Pages and Threads (Meta and Threads app
 * review: the user sees which account gets the post and agrees that Music24 posts for them). These
 * platforms need no stored choice, so their sections hold no form field.
 */
export const accountSectionMessages = defineMessages({
  instagramTitle: { id: 'app.sml.promote.composer.account.instagram.title', defaultMessage: 'Instagram' },
  facebookTitle: { id: 'app.sml.promote.composer.account.facebook.title', defaultMessage: 'Facebook Page' },
  threadsTitle: { id: 'app.sml.promote.composer.account.threads.title', defaultMessage: 'Threads' },
  postingToAccount: { id: 'app.sml.promote.composer.account.postingToAccount', defaultMessage: 'Posting to' },
  postingToPage: { id: 'app.sml.promote.composer.account.postingToPage', defaultMessage: 'Posting to the Page' },
  change: { id: 'app.sml.promote.composer.account.changeInConnections', defaultMessage: 'Change in Connections' },
  onBehalf: {
    id: 'app.sml.promote.composer.account.onBehalfConnections',
    defaultMessage:
      'MUSIC24 posts to {account} for you, at the time you set. It posts what you see here and nothing else. You can disconnect it in Connections at any time.',
  },
  threadsLimit: {
    id: 'app.sml.promote.composer.account.threads.limit',
    defaultMessage: 'A Threads post holds up to {limit} characters. This one has {count}.',
  },
  threadsOverLimit: {
    id: 'app.sml.promote.composer.account.threads.overLimit',
    defaultMessage: 'This post is {over} characters over the limit of Threads. Shorten the caption.',
  },
});
